import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../../../main/initializers/axios';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import IProduct from '../../../main/interfaces/IProduct';
import './Order.css';
import { ITableInvoice } from '../../../main/interfaces/ITableInvocie';
import useGetUser from '../../../main/hooks/useGetUser';
import InvoiceSection from '../invoiceSection/InvoiceSection';
import { toast } from 'react-toastify';
import IInvoiceOrder from '../../../main/interfaces/IInvoiceOrder';
import IProductFilter from '../../../main/interfaces/IProductFilter';
import IProductCategory from '../../../main/interfaces/IProductCategory';
import ITable from '../../../main/interfaces/ITable';
import ISubject from '../../../main/interfaces/ISubject';
import i18n from 'i18next';
import GeneralModal from '../../../main/components/modal/general/GeneralModal';
import { useNavigate } from 'react-router-dom';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { getCachedProductCategories, getCachedProducts, getCachedSubjects } from './restaurantOrderDataCache';
import { IDailyInventoryCurrent } from '../../../main/interfaces/IDailyInventory';


type Props = {
  tableIds: number[];
  table?: any;
  selectedTable?: ITable;
  createOrUpdate: boolean;
  onClick: () => void;
  handleClose: () => void;
    
};

type OrderInvoicePayload = ITableInvoice & {
  subjectId?: string | null;
};

const DAILY_INVENTORY_UPDATED_EVENT = 'dailyInventoryUpdatedAt';

const Orders: React.FC<Props> = (props: Props) => {
//   const [selectedRow, setSelectedRow] = useState<IInvoiceRow | null>(null);
// const [noteValue, setNoteValue] = useState('');
// const [openNoteModal, setOpenNoteModal] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
const [selectedOrder, setSelectedOrder] = useState<IInvoiceOrder | null>(null);
const [note, setNote] = useState('');
  const [tableNote, setTableNote] = useState('');
  const [tableNoteDraft, setTableNoteDraft] = useState('');
  const [tableNoteModalOpen, setTableNoteModalOpen] = useState(false);
  const [exitConfirmOpen, setExitConfirmOpen] = useState(false);
  const { tableIds, createOrUpdate, onClick, handleClose, table, selectedTable } = props;
  const [activeTab, setActiveTab] = useState<number>(1);
  const [products, setProducts] = useState<IProduct[]>([]);
  const [productsCache, setProductsCache] = useState<IProduct[]>([]);
  const [order, setOrder] = useState<{ [key: number]: { product: IProduct; quantity: number } }>({});
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [productFilter, setIProductFilter] = useState<IProductFilter>();
  const [categories, setCategories] = useState<IProductCategory[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [iOrders, setIOrders] = useState<IInvoiceOrder[]>([]);
  const [index, setIndex] = useState<number>(0);
  const [invoice, setInvoice] = useState<ITableInvoice>();
  const user = useGetUser();
  const navigate = useNavigate();
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [subjects, setSubjects] = useState<ISubject[]>([]);
  const [dailyInventory, setDailyInventory] = useState<Record<number, IDailyInventoryCurrent>>({});
  const [selectedSubjectId, setSelectedSubjectId] = useState<string>('');
  const [paymentType, setPaymentType] = useState<number>(1);
  const [bankTransactionPercentage, setBankTransactionPercentage] = useState<number>(0);
  const topRef = useRef<HTMLDivElement | null>(null);
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const contentWrapperRef = useRef<HTMLDivElement | null>(null);
  const invoiceSectionRef = useRef<HTMLDivElement | null>(null);
  const noteInputRef = useRef<HTMLTextAreaElement | null>(null);
  const tableNoteInputRef = useRef<HTMLTextAreaElement | null>(null);
  const invoiceActionInFlightRef = useRef(false);
  const invoiceActionRequestIdRef = useRef<string | null>(null);
  const [isInvoiceActionInFlight, setIsInvoiceActionInFlight] = useState(false);
  const showGoTop = false;
  const isLockedByAnotherUser = selectedTable?.isBusy === true && selectedTable?.usedById != null && selectedTable.usedById !== user?.id;
  const resolveTypeFromTab = (tab: number) => (tab === 2 ? 1 : tab === 3 ? 2 : null);
  const visibleCategories = categories.filter((category) => {
    const typeFilter = resolveTypeFromTab(activeTab);
    return typeFilter == null || category.type === typeFilter;
  });


  const handleOpenNoteModal = (order: IInvoiceOrder) => {
  setSelectedOrder(order);
  setNote(order.note || '');
  setNoteModalOpen(true);
};

const handleSaveNote = () => {
  if (!selectedOrder) return;

  const updatedOrders = iOrders.map((item) => {
    if (item.index === selectedOrder.index) {
      return {
        ...item,
        note: note
      };
    }
    return item;
  });

  setIOrders(updatedOrders);
  setNoteModalOpen(false);
};

  const handleOpenTableNoteModal = () => {
    setTableNoteDraft(tableNote);
    setTableNoteModalOpen(true);
  };

  const handleSaveTableNote = () => {
    const normalizedNote = tableNoteDraft.trim();
    setTableNote(normalizedNote);
    setTableNoteModalOpen(false);
  };




  const applyProductFilters = (tab: number, categoryId: number | null, search: string = searchTerm) => {
    const type = resolveTypeFromTab(tab);
    setActiveTab(tab);
    setSelectedCategoryId(categoryId);
    setIProductFilter((prev) => ({
      ...(prev ?? { Search: null, Category: null, Type: null }),
      Search: search,
      Category: categoryId,
      Type: type,
    }));
    getAllProducts(type, search, categoryId);
  };

  const getInvoiceData = () => {
    setInvoice(null);
    setTableNote('');
    setSelectedSubjectId('');
    axiosInstance.get(`${ApiConstants.invoiceTemp.invoiceByTable}?tableId=${tableIds[0]}`).then((response) => {
      setInvoice(response.data);
      const invoiceName = response.data?.name ?? response.data?.Name ?? '';
      const defaultInvoiceName = `INV TABLE ${tableIds[0]}`;
      setTableNote(invoiceName && invoiceName !== defaultInvoiceName ? invoiceName : '');
      setSelectedSubjectId(response.data?.invoiceSequence?.subjectId ?? response.data?.InvoiceSequence?.SubjectId ?? response.data?.subjectId ?? response.data?.SubjectId ?? '');
    });
  };

  const getSubjects = () => {
    getCachedSubjects().then((data) => setSubjects(data));
  };

  const getDailyInventory = () => {
    axiosInstance
      .get(ApiConstants.dailyInventory.current)
      .then((response) => {
        const items = (response.data ?? []) as IDailyInventoryCurrent[];
        setDailyInventory(
          items.reduce<Record<number, IDailyInventoryCurrent>>((acc, item) => {
            acc[Number(item.productId)] = item;
            return acc;
          }, {}),
        );
      })
      .catch((error) => console.error('Daily inventory could not be loaded', error));
  };

  const getPendingQuantityForProduct = (productId: number) => {
    return iOrders
      .filter((item) => Number(item.product?.id ?? 0) === Number(productId))
      .reduce((sum, item) => sum + Number(item.quantity ?? 0), 0);
  };

  const getInventoryQuantity = (product: IProduct) => {
    const inventory = dailyInventory[Number(product.id)];
    if (!inventory) return null;
    return Number(inventory.quantity ?? 0) - getPendingQuantityForProduct(product.id);
  };

  const getInventoryClassName = (product: IProduct) => {
    const inventory = dailyInventory[Number(product.id)];
    if (!inventory) return 'product-card--inventory-none';
    const remaining = getInventoryQuantity(product) ?? 0;
    if (remaining <= 0) return 'product-card--inventory-out';
    if (remaining <= Number(inventory.warningQuantity ?? 0)) return 'product-card--inventory-warning';
    return 'product-card--inventory-ok';
  };

  const reduceDailyInventoryForRows = async (rows: NonNullable<ITableInvoice['invoiceRows']>) => {
    const reductions = rows.reduce<Record<number, number>>((acc, row) => {
      const productId = Number(row.productId ?? 0);
      const inventory = dailyInventory[productId];
      if (!inventory) return acc;

      acc[productId] = (acc[productId] ?? 0) + Number(row.quantity ?? 0);
      return acc;
    }, {});

    const changedProductIds = Object.keys(reductions).map(Number);
    if (changedProductIds.length === 0) return;

    const updatedInventories = changedProductIds.map((productId) => {
      const inventory = dailyInventory[productId];
      const quantity = Math.max(0, Number(inventory.quantity ?? 0) - reductions[productId]);

      return {
        ...inventory,
        quantity,
      };
    });

    setDailyInventory((prev) => {
      const next = { ...prev };
      updatedInventories.forEach((inventory) => {
        next[Number(inventory.productId)] = inventory;
      });
      return next;
    });

    try {
      await Promise.all(
        updatedInventories.map((inventory) =>
          axiosInstance.post(ApiConstants.dailyInventory.update, {
            id: inventory.id,
            productId: inventory.productId,
            quantity: inventory.quantity,
            warningQuantity: inventory.warningQuantity,
          }),
        ),
      );

      localStorage.setItem(DAILY_INVENTORY_UPDATED_EVENT, String(Date.now()));
    } catch (error) {
      getDailyInventory();
      throw error;
    }
  };

  const getCompanyId = () => {
    if (!user) return 0;
    return user.companyId ?? user.role?.companyId ?? 0;
  };

  const createClientRequestId = () => {
    const cryptoApi = window.crypto as Crypto | undefined;
    if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  };

  const getInvoiceActionRequestId = (suffix: 'print' | 'close') => {
    if (!invoiceActionRequestIdRef.current) {
      invoiceActionRequestIdRef.current = createClientRequestId();
    }

    return `${invoiceActionRequestIdRef.current}:${suffix}`;
  };

  const buildInvoiceRows = () => {
    return iOrders
      .filter((item) => Number(item.quantity ?? 0) > 0)
      .map((item) => ({
        id: 0,
        invoiceId: invoice?.id ?? 0,
        quantity: item.quantity,
        price: Number((item.product.price * item.quantity).toFixed(2)),
        productId: item.product.id,
        companyId: getCompanyId(),
        note: item.note || null
      }));
  };
  const buildEmptyClosePayload = (): ITableInvoice => ({
    id: 0,
    tableId: tableIds[0],
    userId: user?.id ?? 0,
    name: `INV TABLE ${tableIds[0]}`,
    price: 0,
    currentPrice: 0,
    quantity: 0,
      measurmentUnit: 1,
      companyId: getCompanyId(),
      clientRequestId: getInvoiceActionRequestId('close'),
      subjectId: selectedSubjectId || null,
      paymentType,
      created: new Date().toISOString(),
      deleted: null,
      invoiceRows: [],
  });
  const buildInvoicePayload = () => {
    const invoiceRows = buildInvoiceRows();
    const calculatedTotal = invoiceRows.reduce((sum, row) => sum + row.price, 0);

    const tableOrder: OrderInvoicePayload = {
      id: invoice?.id || 0,
      tableId: tableIds[0],
      userId: user?.id ?? 0,
      name: tableNote || `INV TABLE ${tableIds[0]}`,
      price: calculatedTotal,
      currentPrice: calculatedTotal,
      quantity: invoiceRows.length,
      measurmentUnit: 1,
      companyId: getCompanyId(),
      clientRequestId: getInvoiceActionRequestId('print'),
      subjectId: selectedSubjectId || null,
      created: new Date().toISOString(),
      deleted: null,
      invoiceRows: invoiceRows,
    };

    return tableOrder;
  };

  const scrollToTop = () => {
    // Prefer scroll brenda container-it (mobile), fallback window
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const scrollToBottom = () => {
    // Shko te fundi ku janë veprimet e faturës
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollTo({
        top: contentWrapperRef.current.scrollHeight,
        behavior: 'auto',
      });
    } else {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'auto',
      });
    }

    invoiceSectionRef.current?.scrollIntoView({ behavior: 'auto', block: 'end' });

    requestAnimationFrame(() => {
      const invoiceScroller = invoiceSectionRef.current?.querySelector('.oiInv__section') as HTMLDivElement | null;
      if (invoiceScroller) {
        invoiceScroller.scrollTo({
          top: invoiceScroller.scrollHeight,
          behavior: 'auto',
        });
      }
      bottomRef.current?.scrollIntoView({ behavior: 'auto', block: 'end' });
    });
  };

  const isValidInvoice = (inv?: any) =>
    inv !== null && inv !== undefined && inv !== '' && !(typeof inv === 'object' && Object.keys(inv).length === 0);

  const buildClosePayload = (baseInvoice?: ITableInvoice | null, includePendingRows: boolean = true): OrderInvoicePayload => {
    const sourceInvoice = baseInvoice ?? invoice;

   const existingRows = (sourceInvoice?.invoiceRows ?? []).map((r: any) => ({
  ...r,
  id: r.id ?? r.Id ?? 0,
  invoiceId: sourceInvoice?.id ?? 0,
  companyId: getCompanyId(),
  note: r.note ?? r.Note ?? null // 🔥 FIX
}));

    const newRows = includePendingRows ? buildInvoiceRows() : [];

    const mergedRows = [...existingRows, ...newRows].filter((r: any) => Number(r?.quantity ?? 0) > 0);

    const mergedTotal = mergedRows.reduce((sum: number, r: any) => sum + Number(r.price ?? 0), 0);

    return {
      ...(sourceInvoice ?? ({} as ITableInvoice)),
      id: sourceInvoice?.id || 0,
      tableId: tableIds[0],
      userId: user?.id ?? 0,
      name: tableNote || (sourceInvoice as any)?.name || `INV TABLE ${tableIds[0]}`,
      companyId: getCompanyId(),
      clientRequestId: getInvoiceActionRequestId('close'),
      subjectId: selectedSubjectId || (sourceInvoice as any)?.invoiceSequence?.subjectId || (sourceInvoice as any)?.InvoiceSequence?.SubjectId || (sourceInvoice as any)?.subjectId || (sourceInvoice as any)?.SubjectId || null,
      paymentType,
      price: Number(mergedTotal.toFixed(2)),
      currentPrice: Number(mergedTotal.toFixed(2)),
      quantity: mergedRows.length,
      measurmentUnit: (sourceInvoice as any)?.measurmentUnit ?? 1,
      created: (sourceInvoice as any)?.created ?? new Date().toISOString(),
      deleted: null,
      invoiceRows: mergedRows,
    };
  };

  const resetOrderState = () => {
    setOrder({});
    setIOrders([]);
    setProducts(productsCache);
  };

  const closeOrderAndReturnToMap = () => {
    handleClose();
    navigate('/restaurant-map', { replace: true });
  };

  const hasSelectedProducts = () => buildInvoiceRows().length > 0;

  const beginInvoiceAction = () => {
    if (invoiceActionInFlightRef.current) return false;
    invoiceActionRequestIdRef.current = createClientRequestId();
    invoiceActionInFlightRef.current = true;
    setIsInvoiceActionInFlight(true);
    return true;
  };

  const finishInvoiceAction = () => {
    invoiceActionInFlightRef.current = false;
    invoiceActionRequestIdRef.current = null;
    setIsInvoiceActionInFlight(false);
  };

  const handleCloseClick = () => {
    if (hasSelectedProducts()) {
      setExitConfirmOpen(true);
      return;
    }

    handleClose();
  };

  const confirmClosePage = () => {
    setExitConfirmOpen(false);
    handleClose();
  };

  const sendPendingRowsToCounter = async () => {
    const tableOrder: ITableInvoice = buildInvoicePayload();
    const submittedRows = tableOrder.invoiceRows ?? [];

    if (submittedRows.length === 0) {
      return invoice ?? null;
    }

    const res = await axiosInstance.post(ApiConstants.tables.printInvoice, tableOrder);
    void reduceDailyInventoryForRows(submittedRows).catch(() => {
      // The invoice is already persisted; inventory synchronization must not
      // delay or turn the counter action into a failure.
    });
    setInvoice(res.data);
    return res.data;
  };

  const closeInvoice = async (skipFiscalization = false) => {
    if (!beginInvoiceAction()) return;

    try {
      const payload = isValidInvoice(invoice) || hasSelectedProducts()
        ? buildClosePayload(invoice, true)
        : buildEmptyClosePayload();

      await axiosInstance.post(ApiConstants.invoiceTemp.closeInvoice, {
        ...payload,
        skipFiscalization,
      });
      toast.success('Porosia u mbyll me sukses');
      resetOrderState();
      setSelectedSubjectId('');
      setPaymentType(1);
      setInvoice(null);
      closeOrderAndReturnToMap();
    } catch {
      try {
        const response = await axiosInstance.get(`${ApiConstants.invoiceTemp.invoiceByTable}?tableId=${tableIds[0]}`, {
          skipLoader: true,
          skipErrorToast: true,
        } as any);

        if (!response.data) {
          toast.success('Porosia u mbyll me sukses');
          resetOrderState();
          setSelectedSubjectId('');
          setInvoice(null);
          closeOrderAndReturnToMap();
          return;
        }
      } catch {
        // Preserve the order when the authoritative server state is unknown.
      }

      toast.error('Gabim gjate mbylljes se porosise');
    } finally {
      finishInvoiceAction();
    }
  };

  const getAllProducts = (activeT?: number | null, search?: string | null, category?: number | null) => {
    const request = {
      Type: activeT !== undefined ? activeT : productFilter?.Type ?? null,
      Search: search !== undefined ? search : productFilter?.Search ?? null,
      Category: category !== undefined ? category : productFilter?.Category ?? null,
    };
    getCachedProducts(request).then((data) => {
      setProducts(data);
      setProductsCache(data);
    });
  };

  const getProductCategories = () => {
    getCachedProductCategories().then((data) => setCategories(data));
  };

  const handleInputChange = (e: any) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      setIProductFilter((prev) => {
        const next = {
          ...(prev ?? { Search: null, Category: null, Type: null }),
          Search: value,
          Category: selectedCategoryId ?? null,
          Type: resolveTypeFromTab(activeTab),
        };
        // nëse do, thirre getAllProducts me next (pa u varur nga state async)
        getAllProducts(next.Type ?? null, next.Search, next.Category ?? null);
        return next;
      });
    }, 1000);
  };

  const handleClearSearch = () => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    const activeType = resolveTypeFromTab(activeTab);
    setSearchTerm('');
    setIProductFilter((prev) => ({
      ...(prev ?? { Search: null, Category: null, Type: null }),
      Search: null,
      Category: selectedCategoryId ?? null,
      Type: activeType,
    }));
    getAllProducts(activeType, null, selectedCategoryId ?? null);
  };

  const updateOrder = (ord: IInvoiceOrder, product: IProduct, delta: number, isEditingOnInvoice: boolean) => {
    if (delta == null || delta == undefined || isNaN(delta)) delta = 0;
    const isEditableProduct = Boolean(product?.isEditable);

    if (ord) {
      ord.quantity = isEditableProduct ? Math.max(0, delta) : Math.max(0, Math.round(delta));
      ord.price = product.price * ord.quantity;
      ord.price = Number(ord.price.toFixed(2));
      ord.isEdited = true;
      UpdateOrderArray(ord);
    } else {
      const o = iOrders.find((x) => x.product.id == product.id && x.isEdited == false);
      if (o) {
        const nextQuantity = isEditingOnInvoice ? (isEditableProduct ? Math.max(0, delta) : Math.max(0, Math.round(delta))) : o.quantity + delta;

        o.quantity = nextQuantity;
        o.price = product.price * o.quantity;
        o.isEdited = false;
        UpdateOrderArray(o);
      } else {
        if (!isEditableProduct && delta <= 0) return;
        const newOrder = addOrder(product, delta);
        setIOrders([...iOrders, newOrder]);
      }
    }
  };

  const updateTotal = () => {
    const ordersTotal = iOrders.reduce((sum, item) => sum + item.price, 0);
    setTotalPrice(ordersTotal);
  };

  function remoceOrderArray(ord: IInvoiceOrder) {
    const orderss = iOrders.filter((x) => {
      if (typeof ord.index === 'number' && typeof x.index === 'number') {
        return x.index !== ord.index;
      }
      return x.product.id !== ord.product.id;
    });
    setIOrders(orderss);
  }

  function UpdateOrderArray(ord: IInvoiceOrder) {
    const updatedOrders = iOrders.map((item) => {
      if (item.index === ord.index) {
        return {
          ...item,
          quantity: ord.quantity,
          isEdited: ord.isEdited,
          price: ord.price,
        };
      }
      return item;
    });
    setIOrders(updatedOrders);
  }

  function addOrder(product: IProduct, quantity: number) {
    setIndex(index + 1);
    const normalizedQuantity = product?.isEditable ? Math.max(0, quantity) : Math.max(1, Math.round(quantity));

    return {
  index: index,
  product: product,
  quantity: normalizedQuantity,
  price: Number((product.price * normalizedQuantity).toFixed(2)),
  isEdited: false,
  note: '' 
};
  }

  const handleInvoiceCreation = async () => {
    if (!beginInvoiceAction()) return;

    if (buildInvoiceRows().length === 0) {
      finishInvoiceAction();
      return toast.info('Selekto ndonje produkt');
    }

    try {
      await sendPendingRowsToCounter();
      toast.success('Porosia u ruajt me sukses');
      resetOrderState();
      closeOrderAndReturnToMap();
    } catch {
      toast.error('Gabim gjate dergimit ne banak');
    } finally {
      finishInvoiceAction();
    }
  };

  useEffect(() => {
    updateTotal();
  }, [iOrders, invoice]);

  useEffect(() => {
    if (createOrUpdate) {
      handleInvoiceCreation();
      onClick();
    }
  }, [createOrUpdate]);

  useEffect(() => {
    setIProductFilter({ Search: null, Category: null, Type: null });
    getAllProducts(null, null, null);
    getProductCategories();
    getSubjects();
    getDailyInventory();
    getInvoiceData();
    axiosInstance
      .get<{ bankTransactionPercentage?: number | null }>('/api/company', {
        skipLoader: true,
        skipErrorToast: true,
      } as any)
      .then((response) => {
        const percentage = Number(response.data?.bankTransactionPercentage ?? 0);
        setBankTransactionPercentage(Number.isFinite(percentage) ? percentage : 0);
      })
      .catch(() => setBankTransactionPercentage(0));
  }, []);

  useEffect(() => {
    const selectedCategory = categories.find((category) => category.id === selectedCategoryId);
    const activeType = resolveTypeFromTab(activeTab);

    if (selectedCategoryId != null && selectedCategory && activeType != null && selectedCategory.type !== activeType) {
      setSelectedCategoryId(null);
      setIProductFilter((prev) => ({
        ...(prev ?? { Search: null, Category: null, Type: null }),
        Category: null,
        Type: activeType,
      }));
      getAllProducts(activeType, searchTerm, null);
    }
  }, [activeTab, categories, searchTerm, selectedCategoryId]);

  useEffect(() => {
    const total = Object.values(order).reduce((sum, { product, quantity }) => sum + Number(product.price) * quantity, 0);
    setTotalPrice(total);
  }, [order]);

  useEffect(() => {
    if (!noteModalOpen) return;

    requestAnimationFrame(() => {
      noteInputRef.current?.focus();
      const noteLength = noteInputRef.current?.value.length ?? 0;
      noteInputRef.current?.setSelectionRange(noteLength, noteLength);
    });
  }, [noteModalOpen]);

  useEffect(() => {
    if (!tableNoteModalOpen) return;

    requestAnimationFrame(() => {
      tableNoteInputRef.current?.focus();
      const noteLength = tableNoteInputRef.current?.value.length ?? 0;
      tableNoteInputRef.current?.setSelectionRange(noteLength, noteLength);
    });
  }, [tableNoteModalOpen]);

  return (
    <div className="order-container">
      {/* TOP anchor */}
      <div ref={topRef} />

      <div className="order-top-row">
        <div className="table-info">
          <span className="table-name">{table}</span>
          {tableNote && <span className="table-note">{tableNote}</span>}
        </div>

        <div className="search-container-order">
          <input className="search-input" onChange={handleInputChange} type="text" placeholder={i18n.t('generic.search')} value={searchTerm} />
          {searchTerm && (
            <button type="button" className="search-clear-btn" onClick={handleClearSearch} aria-label="Clear search" title="Clear search">
              <DeleteOutlineIcon fontSize="small" />
            </button>
          )}
        </div>

        {!searchTerm.trim() && (
          <button className="close-btn" onClick={handleCloseClick} aria-label="Close">
            X
          </button>
        )}
      </div>

      <div className="tabs-row">
        <div className="tabs">
          <button type="button" className="tab tab--elevator" onClick={scrollToBottom} title="Shko poshte te fatura" aria-label="Scroll to invoice">
            ↓
          </button>
          <button
            onClick={() => {
              applyProductFilters(1, null);
            }}
            className={`tab ${activeTab === 1 ? 'active' : ''}`}
          >
            {i18n.t('tables.all')}
          </button>

          <button
            onClick={() => {
              applyProductFilters(2, selectedCategoryId);
            }}
            className={`tab ${activeTab === 2 ? 'active' : ''}`}
          >
            {i18n.t('productType.Bar')}
          </button>

          <button
            onClick={() => {
              applyProductFilters(3, selectedCategoryId);
            }}
            className={`tab ${activeTab === 3 ? 'active' : ''}`}
          >
            {i18n.t('productType.Restaurant')}
          </button>

          {visibleCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => {
                const nextCategoryId = selectedCategoryId === category.id ? null : category.id ?? null;
                applyProductFilters(activeTab, nextCategoryId);
              }}
              className={`tab tab--category ${selectedCategoryId === category.id ? 'active' : ''}`}
            >
              {category.name}
            </button>
          ))}

          {/* Elevator DOWN button next to filters */}
          <button type="button" className="elevator-btn" onClick={scrollToBottom} title="Shko poshtë te fatura">
            ↓
          </button>
        </div>
      </div>

      <div className="content-wrapper" ref={contentWrapperRef}>
        <div className="products-section" id="products-section">
          <div className="product-grid">
            {products.map((product) => (
              (() => {
                const currentQuantity = getInventoryQuantity(product);
                const inventory = dailyInventory[Number(product.id)];
                return (
              <button
                key={product.id}
                type="button"
                className={`product-card ${getInventoryClassName(product)}`}
                title={`${product.name} - ${product.price}${currentQuantity != null ? ` | Gjendje: ${currentQuantity}` : ''}`}
                onClick={() => updateOrder(null, product, 1, false)}
              >
                <div className="product-code">{product.code}</div>
                {inventory && <div className="product-stock-badge">{currentQuantity}</div>}
              </button>
                );
              })()
            ))}
          </div>
        </div>

        <div className="invoice-section" id="invoice-section" ref={invoiceSectionRef}>
          <InvoiceSection
            order={order}
            neworder={iOrders}
            totalPrice={totalPrice}
            invoice={invoice}
            canManageTableActions={!isLockedByAnotherUser}
            isInvoiceActionInFlight={isInvoiceActionInFlight}
            handleCloseInvoice={closeInvoice}
            updateOrder={(item, product, quantity, isEditingOnInvoice) => updateOrder(item, product, quantity, isEditingOnInvoice)}
            removeOrder={(item) => remoceOrderArray(item)}
            closeAction={handleClose}
            handleCloseTemp={handleInvoiceCreation}
            onScrollTop={scrollToTop}
            subjects={subjects}
            selectedSubjectId={selectedSubjectId}
            onSubjectChange={setSelectedSubjectId}
            paymentType={paymentType}
            bankTransactionPercentage={bankTransactionPercentage}
            onPaymentTypeChange={(value) => {
              setPaymentType(value);
            }}
            onEditNote={handleOpenNoteModal}
            tableNote={tableNote}
            onEditTableNote={handleOpenTableNoteModal}
          />

{noteModalOpen && (
  <GeneralModal
    headerName={i18n.t('generic.note') || "Shënim për produktin"}
    handleClose={() => setNoteModalOpen(false)}
    handleClick={handleSaveNote}
    variant="default"
    width="520px"
  >
    <div className="orderNoteModal">
      <div className="orderNoteModal__hero">
        {/* <div className="orderNoteModal__eyebrow">Restaurant note</div> */}
        <h4 className="orderNoteModal__title">{selectedOrder?.product?.name}</h4>
        {/* <p className="orderNoteModal__hint">Shto nje udhezim te shkurter per kuzhinen ose nje detaj shtese per kete produkt.</p> */}
      </div>
      <div className="orderNoteModal__field">
        <label className="orderNoteModal__label" htmlFor="order-note-textarea">
          Shenimi
        </label>
      <textarea
        id="order-note-textarea"
        ref={noteInputRef}
        className="orderNoteModal__textarea"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Shto nje shenim per kuzhinen"
        maxLength={50}
        autoFocus
      />
      </div>
      <div className="orderNoteModal__footer">
        {/* <span className="orderNoteModal__tip">Do te shfaqet ne porosi si shenim per produktin.</span> */}
        <span className="orderNoteModal__counter">{note.length}/50</span>
      </div>
    </div>
  </GeneralModal>
)}

{tableNoteModalOpen && (
  <GeneralModal
    headerName="Shenim per tavolinen"
    handleClose={() => setTableNoteModalOpen(false)}
    handleClick={handleSaveTableNote}
    variant="default"
    width="520px"
  >
    <div className="orderNoteModal">
      <div className="orderNoteModal__hero">
        <h4 className="orderNoteModal__title">{table}</h4>
      </div>
      <div className="orderNoteModal__field">
        <label className="orderNoteModal__label" htmlFor="table-note-textarea">
          Shenimi
        </label>
        <textarea
          id="table-note-textarea"
          ref={tableNoteInputRef}
          className="orderNoteModal__textarea"
          value={tableNoteDraft}
          onChange={(event) => setTableNoteDraft(event.target.value)}
          placeholder="Shto nje shenim per tavolinen"
          maxLength={250}
          autoFocus
        />
      </div>
      <div className="orderNoteModal__footer">
        <span className="orderNoteModal__counter">{tableNoteDraft.length}/250</span>
      </div>
    </div>
  </GeneralModal>
)}

{exitConfirmOpen && (
  <GeneralModal
    headerName={i18n.t('generic.confirmation')}
    handleClose={() => setExitConfirmOpen(false)}
    handleClick={confirmClosePage}
    variant="warning"
    width="520px"
    height="260px"
    footerActionsSpread
    cancelText={i18n.t('generic.cancel')}
    confirmText={i18n.t('generic.leave', { defaultValue: 'Largohu' })}
  >
    <p style={{ margin: 0, fontSize: 16, lineHeight: 1.5 }}>
      {i18n.t('tables.confirmLeaveOrderPage', {
        defaultValue: 'Ke produkte te zgjedhura. A je i sigurt qe deshiron te largohesh nga faqja?',
      })}
    </p>
  </GeneralModal>
)}


          {/* BOTTOM anchor */}
          <div ref={bottomRef} />
        </div>
      </div>

      {/* Elevator UP button (bottom-right) */}
      {showGoTop && (
        <button type="button" className="elevator-btn elevator-btn--bottom" onClick={scrollToTop} title="Shko lart">
          ↑
        </button>
      )}
    </div>
  );
};

export default Orders;
